/**
 * VWO (Visual Website Optimizer) A/B Testing Script
 *
 * This composable conditionally loads the VWO script based on:
 * - Feature flag: NUXT_PUBLIC_VWO_ENABLED=true (off by default)
 * - Environment: Only loads in production (not homolog/staging/development)
 * - Route: Excludes embedded checkout, widgets, and booking solution (subdomains)
 *
 * The script is loaded synchronously in <head> to prevent flash of content
 * during A/B test variant application. The experiments-bridge stub is injected
 * immediately before it so campaign JS can call `window.kftExperiments.*`
 * without waiting for Nuxt to hydrate.
 */

import { getExperimentsBridgeStubScript } from '~/composables/useBookNowExperiment'

const VWO_ACCOUNT_ID = 956526
const VWO_VERSION = 2.2
const VWO_SETTINGS_TOLERANCE = 2000

// VWO inline script - must be synchronous to prevent FOUC during A/B tests
export const getVwoInlineScript = () => `
window._vwo_code ||
(function () {
var w=window,
d=document;
var account_id=${VWO_ACCOUNT_ID},
version=${VWO_VERSION},
settings_tolerance=${VWO_SETTINGS_TOLERANCE},
hide_element='body',
hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;';
/* DO NOT EDIT BELOW THIS LINE */
var f=0, v;
if(f=!1,v=d.querySelector('#vwoCode'),cc={},-1<d.URL.indexOf('__vwo_disable__')||w._vwo_code)return;try{var e=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=e&&'object'==typeof e?e:{}}catch(e){}function r(t){try{return decodeURIComponent(t)}catch(e){return t}}var s=function(){var e={combination:[],combinationChoose:[],split:[],exclude:[],uuid:null,consent:null,optOut:null},t=d.cookie||'';if(!t)return e;for(var n,i,o=/(?:^|;\\s*)(?:(_vis_opt_exp_(\\d+)_combi=([^;]*))|(_vis_opt_exp_(\\d+)_combi_choose=([^;]*))|(_vis_opt_exp_(\\d+)_split=([^:;]*))|(_vis_opt_exp_(\\d+)_exclude=[^;]*)|(_vis_opt_out=([^;]*))|(_vwo_global_opt_out=[^;]*)|(_vwo_uuid=([^;]*))|(_vwo_consent=([^;]*)))/g;null!==(n=o.exec(t));)try{n[1]?e.combination.push({id:n[2],value:r(n[3])}):n[4]?e.combinationChoose.push({id:n[5],value:r(n[6])}):n[7]?e.split.push({id:n[8],value:r(n[9])}):n[10]?e.exclude.push({id:n[11]}):n[12]?e.optOut=r(n[13]):n[14]?e.optOut=!0:n[15]?e.uuid=r(n[16]):n[17]&&(i=r(n[18]),e.consent=i&&3<=i.length?i.substring(0,3):null)}catch(e){}return e}();function i(){var e=function(){if(w.VWO&&Array.isArray(w.VWO))for(var e=0;e<w.VWO.length;e++){var t=w.VWO[e];if(Array.isArray(t)&&('setVisitorId'===t[0]||'setSessionId'===t[0]))return!0}return!1}(),t='a='+account_id+'&u='+encodeURIComponent(w._vis_opt_url||d.URL)+'&vn='+version+'&ph=1'+('undefined'!=typeof platform?'&p='+platform:'')+'&st='+w.performance.now();e||((n=function(){var e,t=[],n={},i=w.VWO&&w.VWO.appliedCampaigns||{};for(e in i){var o=i[e]&&i[e].v;o&&(t.push(e+'-'+o+'-1'),n[e]=!0)}if(s&&s.combination)for(var r=0;r<s.combination.length;r++){var a=s.combination[r];n[a.id]||t.push(a.id+'-'+a.value)}return t.join('|')}())&&(t+='&c='+n),(n=function(){var e=[],t={};if(s&&s.combinationChoose)for(var n=0;n<s.combinationChoose.length;n++){var i=s.combinationChoose[n];e.push(i.id+'-'+i.value),t[i.id]=!0}if(s&&s.split)for(var o=0;o<s.split.length;o++)t[(i=s.split[o]).id]||e.push(i.id+'-'+i.value);return e.join('|')}())&&(t+='&cc='+n),(n=function(){var e={},t=[];if(w.VWO&&Array.isArray(w.VWO))for(var n=0;n<w.VWO.length;n++){var i=w.VWO[n];if(Array.isArray(i)&&'setVariation'===i[0]&&i[1]&&Array.isArray(i[1]))for(var o=0;o<i[1].length;o++){var r,a=i[1][o];a&&'object'==typeof a&&(r=a.e,a=a.v,r&&a&&(e[r]=a))}}for(r in e)t.push(r+'-'+e[r]);return t.join('|')}())&&(t+='&sv='+n)),s&&s.optOut&&(t+='&o='+s.optOut);var n=function(){var e=[],t={};if(s&&s.exclude)for(var n=0;n<s.exclude.length;n++){var i=s.exclude[n];t[i.id]||(e.push(i.id),t[i.id]=!0)}return e.join('|')}();return n&&(t+='&e='+n),s&&s.uuid&&(t+='&id='+s.uuid),s&&s.consent&&(t+='&consent='+s.consent),w.name&&-1<w.name.indexOf('_vis_preview')&&(t+='&pM=true'),w.VWO&&w.VWO.ed&&(t+='&ed='+w.VWO.ed),t}code={script:v,nonce:v&&v.nonce,library_tolerance:function(){return'undefined'!=typeof library_tolerance?library_tolerance:void 0},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return performance.getEntriesByName('first-contentful-paint')[0]?'':'string'==typeof cc.hE?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){var t;f||(f=!0,(t=d.getElementById('_vis_opt_path_hides'))&&t.parentNode.removeChild(t),e&&((new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e))},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript',e.src?t.src=e.src:t.text=e.text,v&&t.setAttribute('nonce',v.nonce),d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){t=t||{};var n=new XMLHttpRequest;n.open('GET',e,!0),n.withCredentials=!t.dSC,n.responseType=t.responseType||'text',n.onload=function(){if(t.onloadCb)return t.onloadCb(n,e);200===n.status?_vwo_code.addScript({text:n.responseText}):_vwo_code.finish('&e=loading_failure:'+e)},n.onerror=function(){if(t.onerrorCb)return t.onerrorCb(e);_vwo_code.finish('&e=loading_failure:'+e)},n.send()},init:function(){var e,t=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish()},t),'body'!==this.hide_element()?(n=d.createElement('style'),e=(t=this.hide_element())?t+this.hide_element_style():'',t=d.getElementsByTagName('head')[0],n.setAttribute('id','_vis_opt_path_hides'),v&&n.setAttribute('nonce',v.nonce),n.setAttribute('type','text/css'),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(d.createTextNode(e)),t.appendChild(n)):(n=d.getElementsByTagName('head')[0],(e=d.createElement('div')).style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;',e.setAttribute('id','_vis_opt_path_hides'),e.classList.add('_vis_hide_layer'),n.parentNode.insertBefore(e,n.nextSibling));var n='https://dev.visualwebsiteoptimizer.com/j.php?'+i();-1!==w.location.search.indexOf('_vwo_xhr')?this.addScript({src:n}):this.load(n+'&x=true',{l:1})}};w._vwo_code=code;code.init();})();
`

/**
 * The `<head>` scripts, in the order they must be emitted.
 *
 * The experiments-bridge stub MUST stay first: VWO applies campaign changes as
 * soon as its settings land, well before hydration, so `window.kftExperiments`
 * has to already exist when the snippet after it runs. Emitting them from one
 * array keeps that ordering a property of this list rather than of head-tag
 * priority resolution.
 */
export const getVwoHeadScripts = () => [
  {
    key: 'kftExperimentsStub',
    innerHTML: getExperimentsBridgeStubScript(),
    type: 'text/javascript',
  },
  {
    key: 'vwoCode',
    innerHTML: getVwoInlineScript(),
    type: 'text/javascript',
  },
]

/**
 * Determines if VWO should be loaded based on current context
 */
export const shouldLoadVwo = (
  vwoEnabled: boolean,
  appEnv: string | undefined,
  routePath: string,
  isSubdomain: boolean
): boolean => {
  if (!vwoEnabled) {
    return false
  }

  const isProduction = appEnv === 'production' || appEnv === 'prod'
  if (!isProduction) {
    return false
  }

  // Don't load on Booking Solution (subdomains)
  if (isSubdomain) {
    return false
  }

  // Don't load on embedded checkout or widgets
  // These patterns work with locale prefixes (e.g., /de-de/embedded/booking)
  const isExcludedRoute =
    routePath.includes('/embedded/') || routePath.includes('/widgets/')
  if (isExcludedRoute) {
    return false
  }

  return true
}

/**
 * Composable to conditionally load VWO A/B testing script
 *
 * Must be called in app.vue or a layout to ensure it runs on all pages.
 * The script loads synchronously in <head> to prevent flash during A/B tests.
 */
export const useVwoScript = () => {
  const config = useRuntimeConfig()
  const route = useRoute()
  const isSubdomain = useIsSubdomain()

  const shouldLoad = computed(() =>
    shouldLoadVwo(
      config.public.vwoEnabled,
      config.public.appEnv,
      route.path,
      isSubdomain.value
    )
  )

  // Use useHead to conditionally inject the VWO script
  useHead(() => {
    if (!shouldLoad.value) {
      return {}
    }

    return {
      link: [
        {
          rel: 'preconnect',
          href: 'https://dev.visualwebsiteoptimizer.com',
        },
      ],
      script: getVwoHeadScripts(),
    }
  })

  return {
    shouldLoad,
  }
}
